module.exports = __webpack_public_path__ + "img/goal-eight-en.6d678190.png";